import { Component, OnInit } from '@angular/core';
import { ModalsService } from 'src/app/core/services/modals/modals.service';
import { HerramientasService } from './../../../../core/services/miscellaneous/herramientas.service';
import { ReporteriaService } from './../../../../core/services/http/reporteria/reporteria.service';
import { SweetAlertService } from './../../../../core/services/sweet-alert/sweet-alert.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-modal-herramientas',
  templateUrl: './modal-herramientas.component.html',
  styleUrls: ['./modal-herramientas.component.css']
})
export class ModalHerramientasComponent implements OnInit {
  primeraClave: any = '';
  segundaClave: any = '';
  claveForm: any = '';
  contador = 0;

  label: string;
  disabled: boolean;
  isDisabled: boolean;
  disabledBtn: boolean;
  mostrarOpciones: boolean;
  mostrarError: boolean;

  constructor(
    private modalService: ModalsService,
    private herramientasService: HerramientasService,
    private sweetAlertService: SweetAlertService,
    private reporteriaService: ReporteriaService
  ) { }

  ngOnInit() {
    this.label = 'Primera Clave';
    this.mostrarOpciones = false;
    this.disabled = true;
    this.isDisabled = false;
    this.disabledBtn = false;
  }

  addNumber(numero: string) {
    this.claveForm += numero;
  }

  deleteNumber() {
    this.claveForm = this.claveForm.slice(0, -1);
  }

  validaForm() {
    if (this.claveForm.length <= 2) {
      this.disabled = true;
      this.disabledBtn = false;
      this.mostrarError = false;
    } else {
      this.disabled = false;
      this.disabledBtn = true;
      this.mostrarError = false;
    }
  }

  async changeForm(e: any, formulario: NgForm) {
    this.contador += 1;
    this.disabledBtn = false;
    this.isDisabled = true;
    this.disabled = true;

    if (this.contador === 1) {
      this.primeraClave = this.claveForm.trim();
      const responsePrimeraClave = await this.herramientasService.compararClave(this.primeraClave.toString(), 1);

      if (responsePrimeraClave) {
        this.claveForm = '';
        this.label = 'Segunda Clave';
        this.disabled = true;
        this.isDisabled = false;
        this.mostrarError = false;
      } else {
        this.contador = 0;
        this.disabled = false;
        this.isDisabled = false;
        this.mostrarError = true;
      }
    } else if (this.contador === 2) {
      this.segundaClave = this.claveForm;

      const responseSegundaClave = await this.herramientasService.compararClave(this.segundaClave.toString(), 2);

      if (responseSegundaClave) {
        this.mostrarOpciones = true;
        this.disabled = true;
        this.isDisabled = true;
        this.disabledBtn = true;
        this.mostrarError = false;
      } else {
        this.contador = 1;
        this.disabled = false;
        this.isDisabled = false;
        this.mostrarError = true;
      }
    }
  }

  closeModal() {
    this.modalService.closeModal();
  }

  async apagar() {
    const confirm = await this.sweetAlertService.swalToolConfirmation('Confirmación', 'warning', 'apagar');

    if (confirm) {
      this.sweetAlertService.swalLoading();
      const response = await this.herramientasService.apagarEquipo();
      this.sweetAlertService.swalClose();

      if (response['status']) {
        this.reporteUsabilidad('Apagar equipo', 'Solicitud de apagar equipo exitosa.', true);
      } else {
        this.reporteUsabilidad('Apagar equipo', 'Solicitud de apagar equipo fallida', false);
      }
    }
  }

  async reiniciar() {
    const confirm = await this.sweetAlertService.swalToolConfirmation('Confirmación', 'warning', 'reiniciar');

    if (confirm) {
      this.sweetAlertService.swalLoading();
      const response = await this.herramientasService.reiniciarEquipo();
      this.sweetAlertService.swalClose();

      if (response['status']) {
        this.reporteUsabilidad('Reiniciar equipo', 'Solicitud de reiniciar equipo exitosa.', true);
      } else {
        this.reporteUsabilidad('Reiniciar equipo', 'Solicitud de reiniciar equipo fallida', false);
      }
    }
  }

  async cierreTBK() {
    this.sweetAlertService.swalLoading();
    const response = await this.herramientasService.cierreLlavesTbk();
    this.sweetAlertService.swalClose();

    if (response['status']) {
      this.sweetAlertService.swalToolsAlert('Cierre de Transbank realizado exitosamente.', '¡Éxito!', 'success');
      this.reporteUsabilidad('Cierre de Transbank', 'El cierre de Transbank fue realizado exitosamente.', true);
    } else {
      this.sweetAlertService.swalToolsAlert('Ha ocurrido un error al hacer cierre de Transbank.', '¡Algo salió mal!', 'error');
      this.reporteUsabilidad('Cierre de Transbank', 'Error al hacer cierre de Transbank.', false);
    }
  }

  reporteUsabilidad(recurso: string, respuesta: string, status: boolean) {
    this.reporteriaService.saveLog(
      'Tótem',
      recurso,
      respuesta,
      'Front-End',
      status,
      ''
    );
  }
}
